import {
  PROFILE_ERROR,
  PROFILE_SUCCESS,
  EDIT_PROFILE,
  RESET_PROFILE_FLAG,
} from "./actionTypes"

const initialState = {
  error: null,
  success: null,
  loading: false
}

const profile = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE:
      state = { ...state, loading: true, error:null }
      break
    case PROFILE_SUCCESS:
      state = { ...state, success: action.payload, loading: false, error:null }
      break
    case PROFILE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case RESET_PROFILE_FLAG:
      state = { ...state, success: null, loading: false, error:null }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default profile
